import { AllIcons } from './AllIcons';
import { SingleIcon } from './SingleIcon';
import { Score, ScoreIconStyle } from './types';

export const Scores = [1, 2, 3, 4, 5] as const;

interface ScoreIconProps {
  score: Score;
  style: ScoreIconStyle;
  showAll?: boolean;
  size?: number;
}

export const ScoreIcon = ({
  score,
  style,
  size = 32,
  showAll,
}: ScoreIconProps): JSX.Element => {
  const props = { score, size, scoreIconStyle: style };

  if (!showAll) {
    return <SingleIcon {...props} isSelected={false} />;
  }

  return (
    <div>
      <AllIcons {...props} />
    </div>
  );
};
